import { IProject } from '../repository/project.repository';

export type ProjectDetails = IProject & { filteredCount: number };

export enum ExportCsvMode {
    All,
    WithoutEmail,
    Filtered
}
